import Vue from "vue"
import dayjs from "dayjs";
/**
 * 判断值是否为空，有值则原值返回，为空则返回 "-"
 */
Vue.filter("filterNullValue",function (value){
  const v = "-";
  if(typeof value === "undefined") return v;
  else if(typeof value === 'number' && isNaN(value)) return v;
  else if(value === null) return v;
  return value
})
/**
 * 强制保留两位小数  10112 => 10112.00
 */
Vue.filter("toFixed",function (value){
  let num;
  if(typeof value === 'string') num = parseFloat(value)||0;
  else if(typeof value === 'number' && !isNaN(value)) num = value;
  else return "-"
  return num.toFixed(2);
})

/**
 * 强制保留两位小数，整数每三位用逗号','截断,示例： 2534055.50 ==> 2,534,055.50
 */
Vue.filter("toPrice",function (value){
  let num;
  const len = 3;
  if(typeof value === 'string') num = parseFloat(value)||0;
  else if(typeof value === 'number' && !isNaN(value)) num = value;
  else return "-";
  let beforeSymbol = "";//前面的负数符号
  if(num<0) {
    beforeSymbol = "-";
    num = 0 - num;
  }
  num = num.toFixed(2);
  let arr = num.split('.');
  let str = arr[0];// 整数部分
  if(str.length > len){
    let beforeArr = [];
    let strArr = str.split("");
    do {
      if(strArr.length>len) {
        beforeArr.unshift(strArr.splice(strArr.length-len,len).join(""));
      } else {
        beforeArr.unshift(strArr.join(""));
        strArr.length = 0;
      }
    } while (strArr.length > 0)
    num = beforeArr.join(',') + `.${arr[1]}`;
  }
  return beforeSymbol + num;
})

/**
 * 时间转为 YYYY-MM-DD 格式
 */
Vue.filter("toDate",function (value,style="YYYY-MM-DD"){
  if(!value) return "-";
  return dayjs(value).format(style);
})



// WEBPACK FOOTER //
// ./src/filters/filters.js